import {
  totalCumulativeVotes,
  totalRegVoters,
  numberOfDaysResults,
  top10CumulativeVotes2020,
  top10CumulativeVotes2016,
  top10CumulativeVotes2012,
  maxDemDate,
} from './stats';
import { intcomma } from 'journalize';

// format percent
function apFormatPercent(number) {
  let percent = Math.round(number * 1000) / 10;
  return percent + '%';
}

// get the slots
let dayEarlyVoting = document.querySelector('.day-of-early-voting'),
  dayOfWeekEarlyVoting = document.querySelector('.day-of-week-early-voting'),
  dayEarlyVoting2016 = document.querySelector('.day-of-early-voting-2016'),
  numberEarlyVotes = document.querySelector('.number-early-votes'),
  percentEarlyVotes = document.querySelector('.percent-early-votes'),
  fraction2016EV = document.querySelector('.fraction-early-votes-2016'),
  fraction2012EV = document.querySelector('.fraction-early-votes-2012');

// set day of early voting
// dayEarlyVoting.textContent = numberOfDaysResults;
// dayEarlyVoting2016.textContent = numberOfDaysResults;

// set day of week of early voting
dayOfWeekEarlyVoting.textContent = maxDemDate.format('dddd');

// set number of early votes
numberEarlyVotes.textContent = intcomma(totalCumulativeVotes);

// set percent of votes
percentEarlyVotes.textContent = apFormatPercent(
  totalCumulativeVotes / totalRegVoters
);

// set fraction of 2016 as of the day
// fraction2016EV.textContent = apFormatPercent(
//   top10CumulativeVotes2020 / top10CumulativeVotes2016
// );

// set fraction of 2012 as of the day
// fraction2012EV.textContent = apFormatPercent(
//   top10CumulativeVotes2020 / top10CumulativeVotes2012
// );
